/* import __COLOCATED_TEMPLATE__ from './suggestion-summary-composer.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */

import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type IntlService from 'ember-intl/services/intl';
import type SuggestionService from 'embercom/services/suggestion-service';
import { MAX_SUMMARY_SIZE } from 'embercom/models/article';
import type ArticleContent from 'embercom/models/articles/article-content';

interface Args {
  activeContent: ArticleContent;
}

export default class SuggestionSummaryComposer extends Component<Args> {
  @service declare appService: AppService;
  @service declare intl: IntlService;
  @service declare suggestionService: SuggestionService;

  @tracked editedSummary: string | null = null;

  get app(): $TSFixMe {
    return this.appService.app;
  }

  get entityType() {
    return this.args.activeContent.entityType;
  }

  get currentSummary() {
    return this.editedSummary ?? this.args.activeContent.summary;
  }

  set currentSummary(newSummary: string | undefined) {
    this.editedSummary = newSummary ?? null;
    this.suggestionService.hasDirtyContent = true;
    this.suggestionService.summary = this.editedSummary;
  }

  get maxSummarySize() {
    return MAX_SUMMARY_SIZE;
  }

  get summaryPlaceholder() {
    return this.intl.t('articles.editor.describe-your-article');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::ContentReview::SuggestionSummaryComposer': typeof SuggestionSummaryComposer;
    'knowledge-hub/content-editor/content-review/suggestion-summary-composer': typeof SuggestionSummaryComposer;
  }
}
